/* eslint-disable lingui/no-unlocalized-strings, lingui/text-restrictions -- First Round copy is English-only, like the First Round pages that open it. */
import "./cookie-settings.css";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { useEffect, useId, useState } from "react";

import {
  analyticsAllowed,
  onCookieSettingsOpen,
  openCookieSettings,
  setConsentChoice,
} from "@/client/analytics/consent";

/**
 * Cookie settings (First Round Privacy Policy 7.5): essential cookies, always on, and one switch
 * for analytics. Mounted once in Providers; any CookieSettingsLink opens it.
 */
export const CookieSettingsDialog = () => {
  const [open, setOpen] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const switchId = useId();

  useEffect(
    () =>
      onCookieSettingsOpen(() => {
        setAnalytics(analyticsAllowed());
        setOpen(true);
      }),
    [],
  );

  const save = () => {
    setConsentChoice(analytics ? "granted" : "denied");
    setOpen(false);
  };

  return (
    <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="cks-overlay" />
        <DialogPrimitive.Content className="cks" aria-describedby={undefined}>
          <DialogPrimitive.Close className="cks-close" aria-label="Close">
            <X size={18} aria-hidden="true" />
          </DialogPrimitive.Close>
          <DialogPrimitive.Title className="cks-title">Cookie settings</DialogPrimitive.Title>

          <div className="cks-row">
            <div>
              <p className="cks-name">Essential</p>
              <p className="cks-note">Keep you signed in and remember your settings.</p>
            </div>
            <span className="cks-always">Always on</span>
          </div>

          <div className="cks-row">
            <label htmlFor={switchId}>
              <span className="cks-name">Analytics</span>
              <span className="cks-note">
                Show us how people use the site, like pages visited and clicks, so we can fix what
                gets in the way. Never your audio or video.
              </span>
            </label>
            <input
              id={switchId}
              type="checkbox"
              role="switch"
              className="cks-switch"
              checked={analytics}
              onChange={(event) => setAnalytics(event.target.checked)}
            />
          </div>

          <p className="cks-foot">Saved in this browser. You can change it any time.</p>
          <button type="button" className="cks-save" onClick={save}>
            Save
          </button>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

/** "Cookie settings", styled by the footer or line it sits in. */
export const CookieSettingsLink = ({ className }: { className?: string }) => (
  <button
    type="button"
    className={className ? `cks-link ${className}` : "cks-link"}
    onClick={openCookieSettings}
  >
    Cookie settings
  </button>
);
